import { ChangeDetectionStrategy, Component, Input, input, OnInit } from '@angular/core';
import { ComponentStatus, StateComponent } from '../../../../../../../components/state/state.component';
import { IChampionsLeagueStageBetting, IChampionsLeagueStageFormConfig, IFormBettings, IFormConfig, ITeamLookupDto, ITeamsMetadata, UnderOver } from '@oogaday/shared';
import { UntypedFormGroup } from '@angular/forms';
import { OptionsProviderService } from '../common/services/options-provider.service';
import { IBettingOption, IDropdownConfig } from '../common/model/betting.model';
import { memoize } from 'utils-decorators';
import { ButtonGroupBettingComponent } from '../common/components/button-group-betting/button-group-betting.component';
import { DropdownsBettingComponent } from '../common/components/dropdowns-betting/dropdowns-betting.component';
import { MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle } from '@angular/material/card';

@Component({
  selector: 'oo-champions-league-stage',
  imports: [
    ButtonGroupBettingComponent,
    DropdownsBettingComponent,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardSubtitle,
    MatCardTitle,
  ],
  templateUrl: './champions-league-stage.component.html',
  styleUrl: './champions-league-stage.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChampionsLeagueStageComponent extends StateComponent<ChampionsLeagueStageComponentState> implements OnInit {


  readonly metadata = input.required<ITeamsMetadata>();
  state: ChampionsLeagueStageComponentState = {
    status: 'ready',
    config: null!,
    betting: undefined,
    bettingForm: null!,
    isSubmissionMode: false,
    qualifiersOptions: [],
    notQualifiedOptions: [],
    underOverOptions: [],
    firstPlaceOptions: [],
    lastPlaceOptions: [],
    mostScoringTeamOptions: [],
    leastScoringTeamOptions: [],
    teamToConceiveMostGoalsOptions: [],
    teamToConceiveLeastGoalsOptions: [],
  };


  @Input() set config(config: IFormConfig) {
    this.updateState({ config: config as IChampionsLeagueStageFormConfig });
  }

  @Input() set bettingForm(bettingForm: UntypedFormGroup) {
    this.updateState({ bettingForm });
  }

  @Input() set betting(betting: IFormBettings<any> | undefined) {
    this.updateState({ betting });
  }

  @Input() set isSubmissionMode(isSubmissionMode: boolean) {
    this.updateState({ isSubmissionMode });
  }

  ngOnInit(): void {
    this.updateState({
      qualifiersOptions: OptionsProviderService.getTeamsOptions('Select teams', this.metadata().teams),
      notQualifiedOptions: OptionsProviderService.getTeamsOptions('Select teams', this.metadata().teams),
      underOverOptions: this.state.config.betsConfig.underOver ? OptionsProviderService.getUnderOverOptions(this.state.config.betsConfig.underOver.goals) : undefined,
      firstPlaceOptions: OptionsProviderService.getTeamsOptions('Select a team', this.metadata().teams),
      lastPlaceOptions: OptionsProviderService.getTeamsOptions('Select a team', this.metadata().teams),
      mostScoringTeamOptions: OptionsProviderService.getTeamsOptions('Select a team', this.metadata().teams),
      leastScoringTeamOptions: OptionsProviderService.getTeamsOptions('Select a team', this.metadata().teams),
      teamToConceiveMostGoalsOptions: OptionsProviderService.getTeamsOptions('Select a team', this.metadata().teams),
      teamToConceiveLeastGoalsOptions: OptionsProviderService.getTeamsOptions('Select a team', this.metadata().teams),
    });
  }

  @memoize<any>()
  private groupsToTeams(groups: ITeamLookupDto[][]): ITeamLookupDto[] {
    return groups.flatMap((group) => group)
      .sort((a, b) => a.name < b.name ? -1 : 1);
  }
}

interface ChampionsLeagueStageComponentState {
  status: ComponentStatus;
  config: IChampionsLeagueStageFormConfig;
  betting: IChampionsLeagueStageBetting | undefined;
  bettingForm: UntypedFormGroup;
  isSubmissionMode: boolean;
  qualifiersOptions: IDropdownConfig[];
  notQualifiedOptions: IDropdownConfig[];
  underOverOptions: IBettingOption<UnderOver>[];
  firstPlaceOptions: IDropdownConfig[];
  lastPlaceOptions: IDropdownConfig[];
  mostScoringTeamOptions: IDropdownConfig[];
  leastScoringTeamOptions: IDropdownConfig[];
  teamToConceiveMostGoalsOptions: IDropdownConfig[];
  teamToConceiveLeastGoalsOptions: IDropdownConfig[];
}
